var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup8215(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 393,
    height: 123,
    viewBox: "0 0 393 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_11",
    x: 0,
    y: 0,
    width: 393,
    height: 123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ce0024"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8215",
    "data-name": "Group 8215",
    transform: "translate(-594 -6316)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 594, 6316)",
    filter: "url(#Rectangle_11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    d: "M33,0H312a33,33,0,0,1,33,33V75a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V33A33,33,0,0,1,33,0Z",
    transform: "translate(24 21)",
    fill: "#ce0024"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(676 6353)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(924 6395)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(807 6398)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(915 6346)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(692 6344)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(707 6385)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(818 6346)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(863 6400)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(729 6347)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(787 6348)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(903 6380)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(901 6393)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(685 6396)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(653 6364)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(658 6376)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(750 6405)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(647 6393)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(849 6357)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(924 6373)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(926 6379)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(915 6361)",
    fill: "#e7c16d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8215);
export default __webpack_public_path__ + "static/media/Group 8215.a07bf33ab945c0020cac4c60202c3dad.svg";
export { ForwardRef as ReactComponent };